import apiClient from "./billingServiceClient";

export const startPaymentSetup = async () => {
  const response = await apiClient.post("/payment-setups");
  return response.data;
};

export const attachPaymentMethod = async (paymentMethodId) => {
  const response = await apiClient.put("/payment-setups/attach", {
    paymentMethodId,
  });
  return response.data;
};

export default {
  startPaymentSetup,
  attachPaymentMethod,
};
